import { useAtomValue } from "jotai";
import { FilterSectionResult } from "../../../types/search";
import { searchFilterSectionsAtom } from "./atoms";

/**
 * The filter sections built from the current search's venues, or undefined when the API
 * did not send them — callers then fall back to the full catalogue.
 */
export function useSearchFilterSections(): FilterSectionResult[] | undefined {
  return useAtomValue(searchFilterSectionsAtom);
}
